module.exports = __webpack_public_path__ + "static/media/crumb_icon.71a52687.svg";